<div bsModal #supportInfoModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialogheader" aria-hidden="true">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="dialogheader">
                    <span>Contacting the Helpdesk</span>
                </h5>
                <button type="button" class="close" aria-label="Close" (click)="close()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="info-section">
                    <h6 class="info-section__header">Phone</h6>
                    <p>Phone Number: <a href="tel:+442038801247">+44 20 3880 1247</a></p>
                    <p>Open 09:00 - 17:00 Monday to Friday</p>
                    <p>Voicemail available out of hours</p>
                </div>
                <div class="info-section">
                    <h6 class="info-section__header">Email</h6>
                    <p>Email: <a href="mailto:helpdesk@foureyesinsight.com">helpdesk@foureyesinsight.com</a></p>
                    <p>Open 24HRS</p>
                </div>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/shared/layout/support-info-modal.component.html